export default "__VITE_ASSET__D0lqq4ku__"